module.exports = __webpack_public_path__ + "img/professionalRefurbishment.b4ac3d3.webp";